import { Table } from "../../models/table";
import { UseFormReturn, Path, FieldValues } from "react-hook-form";



/**
 * return the manfacturer id selected in the form. if not selected, return undefined
 * @param useForm 
 * @param manufacturersTable 
 */
export function getManfacturerId<T extends FieldValues>(useForm: UseFormReturn<T>, manufacturersTable?: Table[]): number | undefined{
    const manufacturerIndex = useForm.getValues("manufacturer" as Path<T>) || useForm.getValues("car.manufacturer" as Path<T>);
    const manufacturer: Table | undefined = manufacturersTable?.find(manufacturer => manufacturer.index === manufacturerIndex);
    return manufacturer?.id;
}

